export const MODULE_LIST = {
  USER: 'User',
  COMPANY: 'Company',
  ROLE: 'Roles',
  PERMISSION: 'Permission',
  TEAM: 'Teams',
  SUB_COMPANY: 'SubCompany',
  REPORT: 'Report',
  AMENITIES: 'Amenities',
  TAGS: 'Tags',
  SOURCE: 'Source',
  CATEGORY: 'Category',
  SUB_CATEGORY: 'SubCategory',
  CONFIGURATION: 'Configuration',
  PROPERTY_USAGE: 'PropertyUsage',
  PROPERTY_SIZE: 'PropertySize',
  PROPERTY: 'Property',
  LEAD: 'Leads',
  BANK_ACCOUNT: 'BankAccount',
  PROJECT: 'Project',
  TASKS: 'Tasks',
  TARGETS: 'Targets',
  PAYMENTPLAN: 'PaymentPlan',
  PROJECTCHARGE: 'ProjectCharge',
  DOCUMENTS: 'DocumentTemplate',
  QUOTATION: 'TermsConditions',
  FILE: 'ProjectFiles',
  NOTIFICATION: 'Notification',
  CAMPAIGN: 'Campaign',
  PARTNER_NETWORK: 'PartnerNetwork',
  LEAD_SCORE: 'LeadScore',
  RULES: 'CompanyRules',
  REPORTS: 'Reports',
  CAPTURE_LEAD :'CaptureLeads',
  MYOPERATOR: 'MyOperator',
};
